import registerKWS from './kws'
import { getIntegration } from './registry'

const registerIntegrations = async () => {
	registerKWS()
}

export { getIntegration }

export default registerIntegrations
